import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="company-selector"
export default class extends Controller {
  static targets = ["companyName", "companyVatNumber", "companyId", "results"]

  connect() {
    /*if (!!this.companyIdTarget) {
      let obj = new Object()
      obj.target = { value: this.companyIdTarget.value }
      this.updateVat(obj)
    }*/
  }

  async search() {
    const q = this.companyNameTarget.value.trim()

    if (!q.length) {
      this.clearResults()
      return
    }

    const response = await fetch(`/companies/search.json?query=${encodeURIComponent(q)}`)

    if (response.ok) {
      const data = await response.json()
      this.showResults(data)
    }
  }

  showResults(companies) {
    this.resultsTarget.innerHTML = companies.map(c => `
      <li class="list-group-item list-group-item-action"
          data-action="click->company-selector#select"
          data-id="${c.id}"
          data-name="${c.name}"
          data-vat-number="${c.vat_number}">
        ${c.name}
      </li>
    `).join("")
  }

  /*async updateVat(event) {
    const { value } = event.target
    if (!value) return

    try {
      const response = await fetch(`/companies/${value}`, {
        headers: {"Accept": "text/vnd.turbo-stream.html"}
      });

      if (response.ok) {
        const html = await response.text();
        console.log({html})
        Turbo.renderStreamMessage(html);
      }
    } catch (e) {
      console.error(e);
    }
  }*/

  updateVat(event) {
    if (event && event.type === "change") {
      const { value } = event.target
      if (!value) return
      this.companyVatNumberTarget.value = ""
    }
  }

  updateId(event) {
    if (event && event.type === "change") {
      const { value } = event.target
      if (!value) return
      this.companyIdTarget.value = ""
    }
  }

  select(e) {
    e.preventDefault()

    const li = e.currentTarget
    const { id, name, vatNumber} = li.dataset

    document.getElementById("pass_company_id").value = id
    this.companyNameTarget.value = name
    this.companyVatNumberTarget.value = vatNumber
    this.clearResults()
  }

  clearResults() {
    setTimeout(() => this.resultsTarget.innerHTML = "", 150)
  }
}
